
import { Vue, Component, Watch } from 'vue-property-decorator';
import { Popup, Icon, Field, Button, Toast, CountDown } from 'vant';
import { isWeiXin, isJSON } from '@/common/ts/common';
import { checkForm } from '../utils/check';
import SlideVerify from '../components/SlideVerify.vue';
import { login, webSendMsg, valisendMsg } from '../api';
import Index from './Index.vue';

Vue.use(Popup).use(Icon).use(Button).use(CountDown).use(Field);

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  components: {
    SlideVerify,
  },
})
export default class LoginPage extends Vue {
  show: boolean = true;
  IDNumber: number | string = '';
  telNumber: number | string = '';
  sms: number | string = '';
  isVerify: boolean = false;
  sending: boolean = false;
  resetTime: number = 60;
  password: number | string = '';
  timer: any = null;
  handleClickUpload() {
    this.show = false;
    const date1 = '2021/05/25 17:00';
    const date2 = '2021/06/02 10:00';
    const val1 = new Date(date1).getTime();
    const val2 = new Date().getTime();
    const val3 = new Date(date2).getTime();

    if (this.judgeDate(val1, val2)) {
      Toast('活动未开始');
    }
    // if (this.StartDate(val2, val3)) {
    //   this.$router.push({
    //     path: 'index',
    //   });
    // }
  }
  judgeDate(val1: number, val2: number) {
    return val1 > val2;
  }
  StartDate(val2: number, val3: number) {
    return val3 < val2;
  }
  // 倒计时
  setResetTime() {
    if (!this.sending) {
      this.sending = true;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.resetTime--;
        if (this.resetTime === 0) {
          clearInterval(this.timer);
          this.resetTime = 60;
          this.sending = false;
        }
      }, 1000);
    }
  }
  // fSlideData(res: object) {
  //   this.isVerify = false;
  //   const temp = Object.assign(
  //     { smsType: 1 },
  //     { phone: this.telNumber },
  //     res as any,
  //   );
  //   webSendMsg(temp).then((res: any) => {
  //     if (res.statusCode === 200) {
  //       Toast('获取验证码成功');
  //       this.setResetTime();
  //     } else if (res.statusCode === 100) {
  //       Toast(res.message);
  //     } else {
  //       Toast('获取验证码失败');
  //     }
  //   });
  // }
  handleClickLogin() {
    const date1 = '2021/05/25 17:00';
    const val1 = new Date(date1).getTime();
    const val2 = new Date().getTime();
    if (this.judgeDate(val1, val2)) {
      Toast('活动未开始');
      return;
    }
    this.loginFn();
    // const res = checkForm.start();
    // if (res) {
    //   return Toast(res);
    // } else {
    //   this.loginFn();
    // }
  }
  async loginFn() {
    const data = {
      passWord: this.password,
      chinaId: this.IDNumber,
    };
    const res: any = await login(data);
    try {
      if (res.code === 200) {
        this.successLogin();
        sessionStorage.setItem('id', res.data);
        // this.testMsgCode();
      } else {
        Toast(res.msg);
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 验证短信
  // async testMsgCode() {
  //   const data: any = {
  //     phone: this.telNumber,
  //     code: this.sms,
  //     smsType: 1,
  //   };
  //   const ret: any = await valisendMsg(data);
  //   if (ret.statusCode === 200) {
  //     this.successLogin();
  //   } else {
  //     Toast('验证码错误');
  //   }
  // }

  setStorage(name: string, val: any) {
    const data = JSON.stringify(val);
    sessionStorage.removeItem(name);
    sessionStorage.setItem(name, data);
  }
  successLogin() {
    const data = {
      password: this.password,
      chinaId: this.IDNumber,
    };
    this.setStorage('syUserInfo', data);
    Toast('登录成功!');

    setTimeout(() => {
      this.$router.push('/chuan-mei-liu-yue/upload');
    }, 200);
  }
}
